export const API_BASE_URL = 'https://afrotchop-api-dev.afrimoov.com/api';
export const ALLOWED_ROLES = ['ADMIN', 'MANAGER', 'ADMIN_READ_ONLY'];
